/**
 * Challenge entry entity – user's submission to a challenge (score = max weight).
 */
export function createChallengeEntry({
  id,
  challengeId,
  userId,
  workoutId,
  score,
  createdAt = null,
}) {
  return {
    id,
    challengeId,
    userId,
    workoutId,
    score: Number(score),
    createdAt: createdAt?.toDate?.() ?? createdAt ?? null,
  };
}
